import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useIsEnableBOPIS = () => {
  const settingGlobal = useSelector((state) => state.settingGlobalReducer.settingGlobal);

  return useMemo(() => settingGlobal?.EnableBOPIS, [settingGlobal]);
};

export default useIsEnableBOPIS;